// extracted by mini-css-extract-plugin
export var aboutus = "about-module--aboutus--SDZqp";
export var clubs1 = "about-module--clubs1--U4nBm";
export var clubs2 = "about-module--clubs2--yCv2n";